import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=68c44070&scoped=true"
var script = {}
import style0 from "./Home.vue?vue&type=style&index=0&id=68c44070&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c44070",
  null
  
)

export default component.exports